export default __webpack_public_path__ + "static/media/iplanning02.901e4c35.png";